import * as React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import {
    QUICKTAG_STATUS_NUMBER,
    QUICKTAG_STATUS_TYPES,
    QuickTagInstanceReference
} from '@nexxt/common/types';
import config from '../../config';
import DirectoryCard from '../projects/DirectoryCard';

interface ICodingCardProps {
    key?: number;
    project: QuickTagInstanceReference;
    cardType?: 'full' | 'simple';
    clientTerm?: string;
    showWatermark?: boolean;
}

class CodingCard extends React.Component<ICodingCardProps, null> {
    handleRedirect = (instanceID) => {
        window.location.href = `${config.host.quickTag}/?id=${instanceID}`;
    };

    render() {
        const { key, project, cardType, clientTerm, showWatermark } =
            this.props;
        const isGlobal = project.TenantID === -1;
        const status = project.Status.toString();

        return (
            <DirectoryCard
                key={key}
                isQuicktag
                isDisabled={status == QUICKTAG_STATUS_NUMBER.ANALYZING}
                cardLink={() => {
                    this.handleRedirect(project.QuickTagInstanceID);
                }}
                status={QUICKTAG_STATUS_TYPES[project.Status]}
                name={project.QuestionLabel}
                clientName={project.StudyName}
                lastUpdated={project.LastUpdatedTime.split('T')[0]}
                cardType={cardType}
                showWatermark={showWatermark}
            >
                <React.Fragment>
                    <button
                        className="text-blue inca-card-button disabled:text-blue/60 disabled:cursor-not-allowed"
                        disabled={status == QUICKTAG_STATUS_NUMBER.ANALYZING}
                        onClick={() => {
                            this.handleRedirect(project.QuickTagInstanceID);
                        }}
                    >
                        {status == QUICKTAG_STATUS_NUMBER.ANALYZING
                            ? 'Analyzing'
                            : 'Edit'}
                    </button>
                </React.Fragment>
            </DirectoryCard>
        );
    }
}

const mapStateToProps = (store) => {
    const {
        router: { location }
    } = store;
    return {
        location
    };
};

const mapDispatchToProps = (dispatch) => ({
    changePath: (path) => {
        dispatch(push(path));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(CodingCard);
